import React, { useEffect, useState } from "react";
import { Text } from "@towersystems/roam-common-native";

export type AnimatedDotsProps = {
  count?: number;
  interval?: number;
  text?: string;
};

export const AnimatedDots = ({
  count = 3,
  interval = 450,
  text = "",
}: AnimatedDotsProps) => {
  const [dotCount, setDotCount] = useState(1);
  useEffect(() => {
    const id = setInterval(() => {
      setDotCount((prev) => (prev % count) + 1);
    }, interval);
    return () => clearInterval(id);
  }, [count, interval]);

  const allDots = Array(count)
    .fill(".")
    .map((dot, i) => (i < dotCount ? "." : " "));

  return (
    <Text variant="heading" style={{ textAlign: "center" }}>
      {text}
      {allDots.join("")}
    </Text>
  );
};
